import React, { useState, useEffect } from "react";
import { useGoogleLogin } from "@react-oauth/google";
import { toast } from "react-toastify";
import { useNavigate, Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { loginGoogle, clearRedux } from "../../redux/slices/authSlice";
import "./google-login.css";

const GoogleLoginButton = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(false);
  const { user, error, authSource } = useSelector((state) => state.auth);

  useEffect(() => {
    if (user && authSource === "google") {
      setIsLoading(false);
      toast.success("Đăng nhập thành công");
      dispatch(clearRedux());
      navigate("/");
    }
    if (error && authSource === "google") {
      setIsLoading(false);
      toast.error(error);
      dispatch(clearRedux());
    }
  }, [user, error]);

  const login = useGoogleLogin({
    onSuccess: async (response) => {
      if (response.access_token) {
        setIsLoading(true);
        try {
          const accessToken = response.access_token;
          const userInfoResponse = await fetch(
            "https://www.googleapis.com/oauth2/v3/userinfo",
            {
              headers: {
                Authorization: `Bearer ${accessToken}`,
              },
            }
          );
          const userInfo = await userInfoResponse.json();
          dispatch(loginGoogle(userInfo));
        } catch (error) {
          console.error("Lỗi xử lý đăng nhập:", error);
          toast.error("Đã xảy ra lỗi, vui lòng thử lại!");
        }
      } else {
        toast.error("Đăng nhập Google thất bại!");
      }
    },
    onError: () => {
      toast.error("Đăng nhập Google thất bại!");
    },
  });

  return (
    <>
      {isLoading && (
        <div className="loading-overlay">
          <div className="spinner"></div>
        </div>
      )}
      <Link
        href=""
        className="btn btn-light flex-fill d-flex align-items-center justify-content-center me-2"
        onClick={() => login()} // Chỉ gọi đăng nhập khi click vào nút
      >
        <img
          src="assets/img/icons/google-icon.svg"
          className="me-2"
          alt="Google Logo"
        />
        Google
      </Link>
    </>
  );
};

export default GoogleLoginButton;
